export default "__VITE_ASSET__549b43c8__"